import React, { useMemo } from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import Button from '../../common/button';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { applicationStore } from '../../../store/applicationStore';
import { iframeService } from '../../../services/iframeService';

function SessionExpired() {
  const { sessionExpiredIcon } = useMemo(() => {
    return getGameImages();
  }, []);
  return (
    <Container>
      <Sprite texture={sessionExpiredIcon} x={157} y={8} />
      <Text
        x={186}
        y={95}
        anchor={0.5}
        text={applicationStore.canvasTranslationKeys.SESSION_INACTIVITY}
        style={{
          _fontSize: 16,
          _fontWeight: 500,
          _fontFamily: 'poppinsMedium',
          _fill: '#FFFFFF',
          align: 'center',
          _wordWrap: true,
          _wordWrapWidth: 206,
        }}
        resolution={2}
      />
      <Button
        x={186}
        y={162}
        name='SessionExpired'
        buttonText={applicationStore.canvasTranslationKeys.OK}
        textStyles={{
          _fontSize: 20,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _fontFamily: 'poppinsMedium',
        }}
        handleClickButton={() => {
          iframeService.reloadFrame();
        }}
      />
    </Container>
  );
}
export default SessionExpired;
